import { ArcadeIconNames } from './ArcadeIcon'
import { IconNames as BronteIconNames } from './Icon'

export type OptionalRecord<K extends string | number | symbol, T> = {
  [P in K]?: T
}

export const BRONTE_TO_ARCADE_ICONS_MAPPING_GENERATED: OptionalRecord<BronteIconNames, ArcadeIconNames> = {
  Loan: 'Borrow',
  ShoppingCart: 'ShoppingCart',
  Menu: 'MenuAfterpay',
  Add: 'Add',
  ArrowDown: 'TickerDown',
  ArrowUp: 'TickerUp',
  Bank: 'BankAccount',
  Calendar: 'Date',
  Camera: 'CameraFill',
  Car: 'CategoryAuto',
  Card: 'CardBasic',
  CardUpdate: 'CardInactive',
  CaretDown: 'Expand',
  CaretRight: 'Push',
  CaretUp: 'Collapse',
  Chat: 'CommChat',
  Chatting: 'CommChat',
  Cheque: 'DepositCheck',
  Barcode: 'DepositBarcode',
  Close: 'Close',
  CloseCircle: 'Clear',
  CurrencyExchange: 'SwapCurrency',
  Dollar: 'CurrencyUsd',
  Download: 'Download',
  Edit: 'Edit',
  Email: 'CommEmail',
  Exit: 'LogOut',
  Filter: 'Control',
  Gift: 'Giftcard',
  Globe: 'International',
  Heart: 'Like',
  History: 'Time',
  Home: 'CategoryRent',
  Info: 'InformationOutline',
  Lightning: 'BitcoinLightning',
  Link: 'Hyperlink',
  Location: 'Location',
  Lock: 'LockLocked',
  Message: 'CommSmsFill',
  MobileBanking: 'DeviceMobile',
  MoneyTime: 'PayLater',
  MoneyTransfer: 'TransferWire',
  More: 'More',
  Notification: 'Notifications',
  PasswordHide: 'SensitiveHidden',
  PasswordShow: 'SensitiveVisible',
  Phone: 'CommPhoneFill',
  Pie: 'Data',
  Piggy: 'Savings',
  Profile: 'Avatar',
  Refresh: 'Refresh',
  Refund: 'Refunded',
  Search: 'Search',
  Send: 'Send',
  Settings: 'Control',
  Share: 'Share',
  Shop: 'CategoryShopping',
  Support: 'CardSupport',
  Trash: 'Clear',
  Warning: 'AlertFill',
  // Sale: 'DiscountTagFill',
  // Discount: 'DiscountPercentage',
  // Work: 'Business',
  Star: 'FavoriteFill',
  // 'Star-Hollow': 'Favorite',
  Copy: 'Copy',
  // Location2: 'LocationFill',
  Map: 'LocationDuo',
  Grid: 'PayInFour',
  External: 'LinkOut',
  Box: 'CategoryMoving',
  // Shipping: 'Delivery',
  Bulb: 'Idea',
  Verified: 'AccountVerified',
  Discount2: 'DiscountTag',
  Merchant: 'CategoryShopping',
  Write: 'Edit',
  Attachment: 'Attach',
  CaretLeft: 'BackCentered',
  ArrowLeft: 'TickerLeft',
  ArrowRight: 'TickerRight',
  Printer: 'Printer',
  Order: 'Document',
  Afterpay: 'LogoAfterpay',
  Check: 'Check',
  NewByronPhoneGeneral: 'DeviceMobile',
  NoCreditCheck: 'NoCreditCheck', // This icon has not been correctly mapped in the Figma file, so it has been added manually here. Do not delete or modify until updated in Figma.
} as const
